import { render, staticRenderFns } from "./GastroPosizionamentoBibViewComponent.vue?vue&type=template&id=7e5706fa"
import script from "./GastroPosizionamentoBibViewComponent.vue?vue&type=script&lang=js"
export * from "./GastroPosizionamentoBibViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports